/**
 * Custom error handler for passing response objects
 * back to the error handlers/state tree for easier
 * parsing of status codes, response body, etc.
 */
export default class APIError extends Error {
  constructor(error) {
    super(error);
    this.message = error.message;
    this.response = error.response;
  }
}



// WEBPACK FOOTER //
// ./src/api/APIError.js